// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Menu-module--wrapper--3MIhr"};